
import Page from '@/Page.vue';
import { Component, Prop } from 'vue-property-decorator';
import { MeasureModel } from '@/libs/Api';
import { CrudGetter } from '@/libs/core/+state/models/crud-getter';
import LocationShifts from '@/libs/shifts/components/LocationShifts.vue';
import { measuresStore } from '@/libs/measures/+state/store';
import { CrudAction } from '@/libs/core/+state/models/crud-action';
import { createCrudQueryPayload } from '@/libs/core/+state/models/crud-query-payload';

@Component({
    components: { LocationShifts },
})
export default class MeasureList extends Page {
    @Prop() findingId!: string;

    get measures(): MeasureModel[] {
        return measuresStore.useGetter(CrudGetter.Data, `Measures:${this.findingId}`) ?? [];
    }

    mounted() {
        measuresStore.dispatch(
            CrudAction.GetAll,
            createCrudQueryPayload<MeasureModel>(
                undefined,
                [{ field: 'findingId', op: 'eq', comparand: this.findingId }],
                undefined,
                false,
                `Measures:${this.findingId}`
            )
        );
    }
}
